import React, { Attributes, FC } from 'react';
import { Box, Checkbox, Flex, FlexProps, Text, useBreakpointValue } from '@chakra-ui/react';
import VideoGridItemOverlay from 'ts/common/components/gallery/VideoGridItemOverlay';
import { useTranslate } from 'ts/common/hooks';
import { isVideoOrSlideshow } from 'ts/common/mediaType';
import type { MediaType } from 'ts/common/mediaType';

interface Props extends Attributes {
    isSelected: boolean;
    mediaType?: MediaType;
    onClick?: FlexProps['onClick'];
}

const SelectPhotoOverlay: FC<Props> = ({ isSelected, mediaType, onClick }) => {
    const t = useTranslate('client.store.selectPhotosModal');
    const isLargeScreen = useBreakpointValue({ base: false, lg: true });

    return (
        <Flex
            data-testid="select-photo-overlay"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
            position="relative"
            role="group"
            borderStyle="solid"
            borderWidth="4px"
            borderColor={isSelected ? 'brand.primaryOverlay' : 'transparent'}
            onClick={onClick}
        >
            {/* One overlay for both: neither passes a duration, and the video and slideshow
                overlays draw the same play button. */}
            {isVideoOrSlideshow(mediaType) && <VideoGridItemOverlay />}
            <Flex justifyContent="space-between" zIndex={1}>
                <Box padding="4px">
                    <Checkbox isChecked={isSelected} variant="round" size="xl" readOnly />
                </Box>
            </Flex>
            {isLargeScreen && !isSelected && (
                <Flex
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    position="absolute"
                    height="100%"
                    width="100%"
                    top={0}
                    left={0}
                    background="blackAlpha.500"
                    opacity={0}
                    _groupHover={{ opacity: 1 }}
                    transition="0.25s opacity"
                >
                    <Text color="white">{t('select')}</Text>
                </Flex>
            )}
        </Flex>
    );
};

export default SelectPhotoOverlay;
